
import { ref, defineComponent } from 'vue'
import Tabs from 'primevue/tabs'
import TabList from 'primevue/tablist'
import Tab from 'primevue/tab'
import TabPanels from 'primevue/tabpanels'
import TabPanel from 'primevue/tabpanel'
import Divider from 'primevue/divider'

// Deposit Components
import DepositAuto from '../components/deposit/Auto.vue'
import DepositAutoSlip from '../components/deposit/AutoSlip.vue'
import DepositDecimal from '../components/deposit/Decimal.vue'
import DepositP2P from '../components/deposit/P2P.vue'
import DepositThPay from '../components/deposit/ThPay.vue'
import DepositTrueWallet from '../components/deposit/TrueWallet.vue'
import { useAuthStore } from '../stores/auth';
import { useToast } from 'primevue/usetoast';

export default {
	name: 'WalletDeposit',
	components: {
		Tabs,
		TabPanels,
		TabPanel,
		TabList,
		Tab,
		Divider,

		DepositAuto,
		DepositAutoSlip,
		DepositDecimal,
		DepositP2P,
		DepositThPay,
		DepositTrueWallet,
	},
	props: {
		tabs: {
			type: String,
			default: 'auto',
		},
	},
	setup(props) {
		const auth = useAuthStore();
		auth.hydrate()

		const toast = useToast();

		const tabs = ref<string>(props.tabs)

		const tabComponentMap = {
			auto: DepositAuto,
			slip: DepositAutoSlip,
			decimal: DepositDecimal,
			p2p: DepositP2P,
			thpay: DepositThPay,
			truewallet: DepositTrueWallet,
		}

		const tabTitleMap = {
			auto: 'ฝากด่วน',
			slip: 'ฝากสลิปออโต้',
			decimal: 'ฝากทศนิยม',
			p2p: 'ฝาก P2P',
			thpay: 'ฝาก Qr Code',
			truewallet: 'ฝาก TrueWallet',
		}

		return {
			tabs,
			tabComponentMap,
			tabTitleMap,
		}
	},
};
